export default "__VITE_ASSET__BrcsgKOY__";